<template>
  <!-- 封面 -->
  <div id="container">
    <div class="downPage" @click="onThree" v-if="!isPreview">
      <el-button type="success">下载</el-button>
    </div>
    <div
      class="page"
      v-for="(item, index) in info.list"
      :id="'page' + index"
      :key="index"
    >
      <img
        :src="item.BackCoverImg + '?x-oss-process=style/imgset'"
        crossorigin="anonymous"
        style="
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        "
        alt=""
      />
      <!-- {{ item.Type }} {{ item.PlateId }} -->
      <!-- 封面 -->
      <div
        v-if="item.Type == 1 && item.Answer.length != 0"
        class="pageBody cover"
        style="display: flex; align-items: center; justify-content: center"
      >
        <div class="tui-fateher" style="width: 756px; height: 756px">
          <!-- <img
            id="img"
            crossorigin="anonymous"
            style="width: auto; height: auto; max-width: 100%; max-height: 100%"
            :src="GetUrl(item.Answer[0].Content, 756, 756)"
            alt=""
            srcset=""
          /> -->
          <get-img-url
            :imgUrl="item.Answer[0].Content"
            :height="756"
            :width="756"
          ></get-img-url>
        </div>
        <!-- <img
          crossorigin="anonymous"
          class="avater"
          :src="item.Answer[0].Content + '?x-oss-process=style/imgset'"
        /> -->
        <div class="tui-bgHeader">
          <div>
            <div class="TempType">{{ TempType ? TempType : "" }}</div>
            <div class="CycleName">
              {{ CycleName != "/" && !CycleName ? CycleName : "" }}
            </div>
          </div>
          <div>
            <div class="studentName">{{ info.StudentName }}</div>
            <div class="ClassName">
              {{ info.GradeName }}{{ info.ClassName }}
            </div>
          </div>
        </div>
      </div>
      <!-- 目录 -->
      <div v-if="item.Type == 3" class="pageBody predivBox">
        <div class="catalogue">
          <img
            crossorigin="anonymous"
            src="@/assets/catalogue.png"
            class="icon"
            alt=""
          />

          <div
            v-for="(item, index) in item.muluList"
            class="catalogueItem"
            :key="index"
          >
            <div>
              {{ !item.Title ? Title : item.Title }}
            </div>
            <div>
              {{ item.Page }}
            </div>
          </div>
        </div>
      </div>
      <!-- 运动 -->
      <div v-if="item.Type == 7" class="pageBody exercise">
        <div
          class="exerciseItem"
          v-for="(exerciseItem, exerciseIndex) in item.Answer"
          :key="exerciseIndex"
        >
          <div class="exerciseTitle">
            {{ item.Content[exerciseIndex].title }}
          </div>
          <div class="exerciseInfo">
            <img crossorigin="anonymous" :src="exerciseItem.Content" alt="" />
            <div class="exerciseValue">
              <p>
                标准值：{{ item.Content[exerciseIndex].standardValues
                }}{{ item.Content[exerciseIndex].unit }}
              </p>
              <p>
                实际值：{{ exerciseItem.Value
                }}{{ item.Content[exerciseIndex].unit }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 体检 -->
      <div class="pageBody physical" v-if="item.Type == 8">
        <div class="bgFFF">
          <div class="physicalTitle">
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div class="physicalImage tui-fateher" style="">
            <!-- <img
              crossorigin="anonymous"
              style="
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
              "
              :src="item.Answer[0].Content"
            /> -->
            <get-img-url
              :imgUrl="item.Answer[0].Content"
              :width="711"
              :height="531"
            ></get-img-url>
          </div>
          <!-- <img
            crossorigin="anonymous"
            class="physicalImage"
            :src="item.Answer[0].Content"
            alt=""
          /> -->
          <div class="physicalTime">体检时间：{{ item.Answer[1].Content }}</div>
          <div class="physicalList">
            <div
              v-for="(physicalItem, physicalIndex) in item.Content"
              :key="physicalIndex"
            >
              <!--  -->
              <span v-if="physicalItem.topicType == 'radio'">
                {{ physicalItem.title }}：{{
                  getRadioValue(
                    item.Answer[physicalIndex + 2].Content,
                    physicalItem.answerList
                  )
                }}
              </span>
              <span v-else>
                {{ physicalItem.title }}：
                {{
                  physicalItem.title == "身高"
                    ? `${item.Answer[physicalIndex + 2].Content}CM`
                    : physicalItem.title == "体重"
                    ? `${item.Answer[physicalIndex + 2].Content}KG`
                    : physicalItem.title == "血色素"
                    ? `${item.Answer[physicalIndex + 2].Content}g/L`
                    : physicalItem.title == "龋齿"
                    ? `${item.Answer[physicalIndex + 2].Content}颗`
                    : item.Answer[physicalIndex + 2].Content
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <!-- 结语 10-->
      <div v-if="item.Type == 10" class="pageBody epilogue">
        <div class="bgFFF">
          <div class="epilogueTitle">
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div class="epilogueBody ql-snow">
            <div class="avaterEpilogue">
              <img
                crossorigin="anonymous"
                v-if="item.Answer[0].Operator == 1"
                src="@/assets/avatar2.png"
                alt=""
              />
              <img
                crossorigin="anonymous"
                v-else
                src="@/assets/avatar3.png"
                alt=""
              />
            </div>
            <div
              class="epilogueText ql-editor"
              v-html="item.Answer[0].Content"
            ></div>
          </div>
        </div>
      </div>

      <!-- 图文6 板式1-->
      <div v-if="item.Type == 6 && item.PlateId == 1" class="pageBody">
        <div class="bgFFF">
          <div
            class="PlateIdTitle"
            style="padding-top: 0.54rem; padding-bottom: 50px"
          >
            {{ !item.Title ? Title : item.Title }}
          </div>

          <div
            style="width: 711px; margin: 0 auto; margin-bottom: 30px"
            class="ql-snow"
          >
            <div
              class="tui-text ql-editor"
              v-html="item.Answer[0].Content"
            ></div>
          </div>

          <div
            class="PlateIdOneImage tui-fateher"
            style="height: 400px; margin-bottom: 50px; margin-top: 0"
          >
            <!-- <img
              crossorigin="anonymous"
              style="
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
              "
              :src="item.Answer[1].Content"
              alt=""
              srcset=""
            /> -->
            <get-img-url
              :imgUrl="item.Answer[1].Content"
              :height="400"
              :width="711"
            ></get-img-url>
          </div>
          <div class="PlateIdOneImage tui-fateher" style="height: 400px">
            <!-- <img
              crossorigin="anonymous"
              style="
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
              "
              :src="item.Answer[2].Content"
              alt=""
              srcset=""
            /> -->
            <get-img-url
              :imgUrl="item.Answer[2].Content"
              :height="400"
              :width="711"
            ></get-img-url>
          </div>
        </div>
      </div>
      <!-- 图文6 板式2 -->

      <div
        v-if="item.Type == 6 && item.PlateId == 2"
        :style="{ height: isPreview ? '10.59rem' : '10.59rem' }"
        class="pageBody"
      >
        <div class="bgFFF">
          <div
            class="PlateIdTitle"
            style="padding-top: 0.54rem; padding-bottom: 0.41rem"
          >
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div class="positionBox PlateIdTwo">
            <div
              class="PlateIdTwoImage tui-fateher"
              style="width: 333px; height: 400px"
            >
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[0].Content"
                alt=""
                srcset=""
                @click="onPrediv(item.Answer[0].Content)"
              /> -->
              <get-img-url
                :imgUrl="item.Answer[0].Content"
                :width="333"
                :height="400"
              ></get-img-url>
            </div>
            <!-- <img
              @click="onPrediv(item.Answer[0].Content)"
              crossorigin="anonymous"
              style="width: 333px; height: 400px"
              class="PlateIdImage PlateIdTwoImage"
              :src="item.Answer[0].Content"
              alt=""
              srcset=""
            /> -->
            <div style="width: 354px; top: 0; right: 70px" class="ql-snow">
              <div
                class="tui-text ql-editor"
                v-html="item.Answer[1].Content"
              ></div>
            </div>
            <!-- <div
              class="PlateIdText"
              style="width: 354px; top: 0; right: 70px"
              v-html="getReplace(item.Answer[1].Content)"
            ></div> -->
            <div style="width: 354px; top: 440px; left: 44px" class="ql-snow">
              <div
                class="tui-text ql-editor"
                v-html="item.Answer[2].Content"
              ></div>
            </div>

            <div
              class="PlateIdTwoImage tui-fateher"
              style="width: 333px; height: 400px"
            >
              <get-img-url
                :imgUrl="item.Answer[3].Content"
                :width="333"
                :height="400"
              ></get-img-url>
            </div>

            <div
              class="PlateIdTwoImage tui-fateher"
              style="top: 700px; left: 44px; width: 333px; height: 400px"
            >
              <get-img-url
                :imgUrl="item.Answer[4].Content"
                :width="333"
                :height="400"
              ></get-img-url>
            </div>

            <!-- <div class="ql-snow">
              <div
                class="PlateIdText ql-editor"
                style="width: 354px; top: 800px; right: 70px"
                v-html="item.Answer[5].Content"
              ></div>
            </div> -->
            <div style="width: 354px; top: 800px; right: 70px" class="ql-snow">
              <div
                class="tui-text ql-editor"
                v-html="item.Answer[5].Content"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <!--  图文6 板式3 -->
      <div class="pageBody" v-if="item.Type == 6 && item.PlateId == 3">
        <div class="bgFFF PlateIdThere">
          <div
            class="PlateIdTitle"
            style="padding-top: 0.54rem; padding-bottom: 58px"
          >
            {{ !item.Title ? Title : item.Title }}
          </div>
          <!-- <div
            class="PlateIdText PlateIdThereText"
            v-html="getReplace(item.Answer[0].Content)"
          ></div> -->
          <div
            class="PlateIdText ql-snow"
            style="width: 711px; margin: 0 auto; margin-bottom: 30px"
          >
            <!-- {{ item.Answer[0].isText }} -->
            <div
              class="tui-text ql-editor"
              v-html="item.Answer[0].Content"
            ></div>
            <!-- <el-input
              type="textarea"
              v-model="item.Answer[0].Content"
              disabled
              autosize
            ></el-input> -->
          </div>
          <div class="PlateIdThereImage tui-fateher" style="height: 530px">
            <!-- <img
              crossorigin="anonymous"
              style="
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
              "
              :src="item.Answer[1].Content"
              alt=""
              srcset=""
            /> -->
            <get-img-url
              :imgUrl="item.Answer[1].Content"
              :width="711"
              :height="531"
            ></get-img-url>
          </div>
          <!-- <img
            crossorigin="anonymous"
            :src="item.Answer[1].Content"
            class="PlateIdImage PlateIdThereImage"
            style="height: 360px"
            alt=""
            srcset=""
          /> -->
        </div>
      </div>

      <!-- 图文 板式4 -->
      <div v-if="item.Type == 6 && item.PlateId == 5" class="pageBody">
        <div class="bgFFF">
          <div
            class="PlateIdTitle"
            style="padding-top: 0.54rem; padding-bottom: 70px"
          >
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div class="positionBox PlateIdFive">
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[0].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[0].Content"
                :width="198"
                :height="184"
              ></get-img-url>
            </div>
            <!-- <img
              crossorigin="anonymous"
              :src="item.Answer[0].Content"
              class="PlateIdFourImage"
              alt=""
            /> -->
            <div class="PlateIdFourImage tui-fateher" style="left: 235px">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[1].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[1].Content"
                :width="180"
                :height="235"
              ></get-img-url>
            </div>
            <!-- <img
              crossorigin="anonymous"
              style="left: 235px"
              :src="item.Answer[1].Content"
              class="PlateIdFourImage"
              alt=""
            /> -->

            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[2].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[2].Content"
                :width="136"
                :height="136"
              ></get-img-url>
            </div>

            <!-- <img
              crossorigin="anonymous"
              :src="item.Answer[2].Content"
              class="PlateIdFourImage"
              alt=""
            /> -->
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[3].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[3].Content"
                :width="224"
                :height="287"
              ></get-img-url>
            </div>
            <!-- <img
              crossorigin="anonymous"
              :src="item.Answer[3].Content"
              class="PlateIdFourImage"
              alt=""
            /> -->
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[4].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[4].Content"
                :width="224"
                :height="287"
              ></get-img-url>
            </div>
            <!-- <img
              crossorigin="anonymous"
              :src="item.Answer[4].Content"
              class="PlateIdFourImage"
              alt=""
            /> -->
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[5].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[5].Content"
                :width="224"
                :height="287"
              ></get-img-url>
            </div>
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[6].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[6].Content"
                :width="148"
                :height="169"
              ></get-img-url>
            </div>
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[7].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[7].Content"
                :width="223"
                :height="257"
              ></get-img-url>
            </div>
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[8].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[8].Content"
                :width="122"
                :height="210"
              ></get-img-url>
            </div>
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[9].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[9].Content"
                :width="122"
                :height="101"
              ></get-img-url>
            </div>
          </div>
        </div>
      </div>
      <!-- 图文 板式5 -->
      <div v-if="item.Type == 6 && item.PlateId == 4" class="pageBody">
        <div class="bgFFF" v-if="item.Answer.length != 0">
          <div
            class="PlateIdTitle"
            style="padding-top: 0.54rem; padding-bottom: 98px"
          >
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div class="positionBox PlateIdFour">
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[0].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[0].Content"
                :width="198"
                :height="184"
              ></get-img-url>
            </div>
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[1].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[1].Content"
                :width="180"
                :height="235"
              ></get-img-url>
            </div>
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[2].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[2].Content"
                :width="198"
                :height="184"
              ></get-img-url>
            </div>
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[3].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[3].Content"
                :width="224"
                :height="287"
              ></get-img-url>
            </div>
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[4].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[4].Content"
                :width="224"
                :height="287"
              ></get-img-url>
            </div>
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[5].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[5].Content"
                :width="224"
                :height="287"
              ></get-img-url>
            </div>
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[6].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[6].Content"
                :width="148"
                :height="169"
              ></get-img-url>
            </div>
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[7].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[7].Content"
                :width="223"
                :height="257"
              ></get-img-url>
            </div>
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[8].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[8].Content"
                :width="122"
                :height="210"
              ></get-img-url>
            </div>
            <div class="PlateIdFourImage tui-fateher" style="">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[9].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[9].Content"
                :width="122"
                :height="101"
              ></get-img-url>
            </div>
          </div>
        </div>
      </div>
      <!-- 图文 板式6 -->
      <div class="pageBody" v-if="item.Type == 6 && item.PlateId == 6">
        <div class="bgFFF PlateIdSix">
          <div class="PlateIdSixImage tui-fateher" style="height: 530px">
            <!-- <img
              crossorigin="anonymous"
              :style="{
                width:
                  item.Answer[0].width >= item.Answer[0].height
                    ? '100%'
                    : 'auto',
                height:
                  item.Answer[0].width <= item.Answer[0].height
                    ? '100%'
                    : 'auto',
              }"
              :src="item.Answer[0].Content"
              alt=""
              srcset=""
            /> -->
            <get-img-url
              :imgUrl="item.Answer[0].Content"
              :width="711"
              :height="531"
            ></get-img-url>
          </div>
          <!-- <img
            crossorigin="anonymous"
            :src="item.Answer[0].Content"
            class="PlateIdSixImage"
            style="height: 467px"
            alt=""
          /> -->
          <div class="PlateIdTitle" style="padding: 0.54rem 0 19px 0">
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div class="PlateIdText ql-snow" style="width: 711px; margin: 0 auto">
            <div
              class="tui-text ql-editor"
              v-html="item.Answer[1].Content"
            ></div>
            <!-- <el-input
              type="textarea"
              v-model="item.Answer[1].Content"
              disabled
              autosize
            ></el-input> -->
          </div>
          <!-- <div
            class="PlateIdText"
            style="width: 711px; margin: 0 auto"
            v-html="getReplace(item.Answer[1].Content)"
          ></div> -->
        </div>
      </div>
      <!-- 图文 板式7  -->
      <div class="pageBody" v-if="item.Type == 6 && item.PlateId == 7">
        <div class="bgFFF" v-if="item.Answer.length != 0">
          <div
            class="PlateIdTitle"
            style="padding-top: 0.54rem; padding-bottom: 0.4375rem"
          >
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div class="positionBox PlateIdSevenText">
            <div class="PlateIdSevenImage tui-fateher" style="height: 400px">
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[0].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[0].Content"
                :width="711"
                :height="400"
              ></get-img-url>
            </div>
            <!-- <img
              crossorigin="anonymous"
              :src="item.Answer[0].Content"
              class="PlateIdSevenImage"
              alt=""
            /> -->
            <div
              class="PlateIdSevenImage tui-fateher"
              style="height: 400px; top: 437px"
            >
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[1].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[1].Content"
                :width="326"
                :height="396"
              ></get-img-url>
            </div>
            <!-- <img
              crossorigin="anonymous"
              :src="item.Answer[1].Content"
              class="PlateIdSevenImage"
              alt=""
            /> -->
            <div
              class="PlateIdSevenImage tui-fateher"
              style="height: 400px; top: 437px"
            >
              <!-- <img
                crossorigin="anonymous"
                style="
                  width: auto;
                  height: auto;
                  max-width: 100%;
                  max-height: 100%;
                "
                :src="item.Answer[2].Content"
                alt=""
                srcset=""
              /> -->
              <get-img-url
                :imgUrl="item.Answer[2].Content"
                :width="326"
                :height="396"
              ></get-img-url>
            </div>
            <!-- <img
              crossorigin="anonymous"
              :src="item.Answer[2].Content"
              class="PlateIdSevenImage"
              alt=""
            /> -->
            <div
              style="width: 711px; top: 863px"
              class="PlateIdText PlateIdSixText ql-snow"
            >
              <div
                class="tui-text ql-editor"
                v-html="item.Answer[3].Content"
              ></div>
              <!-- <el-input
                type="textarea"
                v-model="item.Answer[3].Content"
                disabled
                autosize
              ></el-input> -->
            </div>
            <!-- <div
              class="PlateIdText PlateIdSixText"
              style="top: 863px; letter-spacing: 0"
              v-html="getReplace(item.Answer[3].Content)"
            ></div> -->
          </div>
        </div>
      </div>
      <!-- 图文 板式8 -->

      <div class="pageBody" v-if="item.Type == 6 && item.PlateId == 8">
        <div class="bgFFF">
          <div class="PlateIdTitle" style="padding: 0.54rem 0 80px 0">
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div
            class="positionBox PlateIdEightText"
            :style="{ 'margin-top': item.Answer[4].Content ? '0' : '80px' }"
          >
            <div
              class="PlateIdEightImage tui-fateher"
              style="width: 403px; height: 617px"
            >
              <get-img-url
                :imgUrl="item.Answer[0].Content"
                :width="403"
                :height="617"
              ></get-img-url>
            </div>

            <div
              class="PlateIdEightImage tui-fateher"
              style="width: 272px; height: 201px"
            >
              <get-img-url
                :imgUrl="item.Answer[1].Content"
                :width="272"
                :height="201"
              ></get-img-url>
            </div>

            <div
              class="PlateIdEightImage tui-fateher"
              style="width: 272px; height: 201px; top: 208px"
            >
              <get-img-url
                :imgUrl="item.Answer[2].Content"
                :width="272"
                :height="201"
              ></get-img-url>
            </div>

            <div
              class="PlateIdEightImage tui-fateher"
              style="width: 272px; height: 201px; top: 418px"
            >
              <get-img-url
                :imgUrl="item.Answer[3].Content"
                :width="272"
                :height="201"
              ></get-img-url>
            </div>

            <div
              style="width: 711px; margin: 0 auto"
              class="PlateIdText PlateIdEightText ql-snow"
            >
              <div
                class="tui-text ql-editor"
                v-html="item.Answer[4].Content"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 图文 板式9 -->
      <div class="pageBody" v-if="item.Type == 6 && item.PlateId == 9">
        <div class="bgFFF PlateIdNine">
          <div
            class="PlateIdTitle"
            style="padding-top: 0.54rem; padding-bottom: 62px"
          >
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div class="PlateIdNineImage tui-fateher" style="">
            <!-- <img
              crossorigin="anonymous"
              style="
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
              "
              :src="item.Answer[0].Content"
              alt=""
              srcset=""
            /> -->
            <get-img-url
              :imgUrl="item.Answer[0].Content"
              :width="711"
              :height="531"
            ></get-img-url>
          </div>

          <div
            style="width: 711px; margin: 0 auto; margin-top: 14px"
            class="ql-snow"
          >
            <div
              class="tui-text ql-editor"
              v-html="item.Answer[1].Content"
            ></div>
          </div>
        </div>
      </div>
      <!-- 图文 板式10 -->
      <div class="pageBody" v-if="item.Type == 1 && item.PlateId == 10">
        <div class="bgFFFCircle PlateIdTen">
          <div
            class="PlateIdTitle"
            style="padding-top: 213px; padding-bottom: 109px"
          >
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div class="ql-snow">
            <div
              class="PlateIdText PlateIdTenText ql-editor"
              v-html="item.Answer[10].Content"
            ></div>
          </div>
        </div>
      </div>
      <!-- 图文 板式10 -->
      <div
        class="pageBody"
        :style="{ height: isPreview ? '10.59rem' : '10.59rem' }"
        v-if="item.Type == 6 && item.PlateId == 10"
      >
        <div class="bgFFFCircle PlateIdTen">
          <div
            class="PlateIdTitle"
            style="padding-top: 0.7rem; padding-bottom: 0.41rem"
          >
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div
            style="font-size: 22px; width: 623px; margin: 0 auto"
            class="ql-snow"
          >
            <div
              class="tui-text ql-editor"
              v-html="item.Answer[0].Content"
            ></div>
            <!-- <el-input
              type="textarea"
              v-model="item.Answer[0].Content"
              disabled
              autosize
            ></el-input> -->
          </div>
          <!-- <div
            class=""
            style="font-size: 22px; width: 623px; margin: 0 auto"
            v-html="getReplace(item.Answer[0].Content)"
          ></div> -->
        </div>
      </div>
      <!-- 图文版式11 -->
      <div class="pageBody" v-if="item.PlateId == 11">
        <div class="bgFFF PlateIdNine">
          <div
            class="PlateIdTitle"
            style="padding-top: 0.54rem; padding-bottom: 62px"
          >
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div style="width: 711px; margin: 0 auto">
            <div style="padding: 0 0 13px 0; font-size: 34px">老师来加油</div>
            <div class="flex-between">
              <div class="tui-fateher" style="height: 257px; width: 341px">
                <img
                  crossorigin="anonymous"
                  style="
                    width: auto;
                    height: auto;
                    max-width: 100%;
                    max-height: 100%;
                  "
                  :src="getContainImageUrl(item.Answer[0].Content, 341, 257)"
                  alt=""
                  srcset=""
                />
              </div>

              <div class="tui-fateher" style="height: 257px; width: 341px">
                <img
                  crossorigin="anonymous"
                  style="
                    width: auto;
                    height: auto;
                    max-width: 100%;
                    max-height: 100%;
                  "
                  :src="getContainImageUrl(item.Answer[1].Content, 341, 257)"
                  alt=""
                  srcset=""
                />
              </div>
              <!-- <img
                crossorigin="anonymous"
                :src="item.Answer[1].Content"
                class="PlateIdSixImage"
                style="height: 179px; width: 239px"
                alt=""
              /> -->
            </div>
            <div
              class="PlateIdText ql-snow"
              style="width: 711px; margin: 20px auto"
            >
              <div
                class="tui-text ql-editor"
                v-html="item.Answer[2].Content"
              ></div>
              <!-- <el-input
                type="textarea"
                v-model="item.Answer[2].Content"
                disabled
                autosize
              ></el-input> -->
            </div>
            <!-- <div style="margin: 20px auto">
              <div
                class="PlateIdText"
                v-html="getReplace(item.Answer[2].Content)"
              ></div>
            </div> -->
          </div>
          <div style="width: 711px; margin: 0 auto">
            <div style="padding: 0 0 13px 0; font-size: 34px">家长来加油</div>
            <div class="flex-between">
              <div class="tui-fateher" style="height: 257px; width: 341px">
                <img
                  crossorigin="anonymous"
                  style="
                    width: auto;
                    height: auto;
                    max-width: 100%;
                    max-height: 100%;
                  "
                  :src="getContainImageUrl(item.Answer[3].Content, 341, 257)"
                  alt=""
                  srcset=""
                />
              </div>
              <!-- <el-image
                crossorigin="anonymous"
                style="height: 257px; width: 341px"
                :src="item.Answer[3].Content"
                fit="cover"
              ></el-image> -->
              <div class="tui-fateher" style="height: 257px; width: 341px">
                <img
                  crossorigin="anonymous"
                  style="
                    width: auto;
                    height: auto;
                    max-width: 100%;
                    max-height: 100%;
                  "
                  :src="getContainImageUrl(item.Answer[4].Content, 341, 257)"
                  alt=""
                  srcset=""
                />
              </div>
            </div>
            <div
              class="PlateIdText ql-snow"
              style="width: 711px; margin: 20px auto"
            >
              <div
                class="tui-text ql-editor"
                v-html="item.Answer[5].Content"
              ></div>
              <!-- <el-input
                type="textarea"
                v-model="item.Answer[5].Content"
                disabled
                autosize
              ></el-input> -->
            </div>
            <!-- <div style="margin: 20px auto">
              <div
                class="PlateIdText"
                v-html="getReplace(item.Answer[5].Content)"
              ></div>
            </div> -->
          </div>
        </div>
      </div>
      <!-- 图文版式12 -->
      <div class="pageBody" v-if="item.PlateId == 12">
        <div class="bgFFF PlateIdNine">
          <div
            class="PlateIdTitle"
            style="padding-top: 0.54rem; padding-bottom: 20px"
          >
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div style="padding: 0 20px">
            <div style="padding: 0 0 13px 0; font-size: 34px">老师来加油</div>
            <div class="flex-center">
              <div class="tui-fateher" style="height: 330px; width: 523px">
                <get-img-url
                  :imgUrl="item.Answer[0].Content"
                  :height="330"
                  :width="523"
                ></get-img-url>
              </div>
            </div>
            <div
              class="PlateIdText ql-snow"
              style="width: 711px; margin: 20px auto"
            >
              <div
                class="tui-text ql-editor"
                v-html="item.Answer[1].Content"
              ></div>
            </div>
          </div>
          <div style="padding: 0 20px">
            <div style="padding: 0 0 13px 0; font-size: 34px">家长来加油</div>
            <div class="flex-center">
              <div class="tui-fateher" style="height: 330px; width: 523px">
                <get-img-url
                  :imgUrl="item.Answer[2].Content"
                  :height="330"
                  :width="523"
                ></get-img-url>
              </div>
            </div>
            <div
              class="PlateIdText ql-snow"
              style="width: 711px; margin: 20px auto"
            >
              <div
                class="tui-text ql-editor"
                v-html="item.Answer[3].Content"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 图文版式13 -->
      <div class="pageBody" v-if="item.PlateId == 13">
        <div class="bgFFF PlateIdNine">
          <div
            class="PlateIdTitle"
            style="padding-top: 0.54rem; padding-bottom: 20px"
          >
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div
            class="PlateIdEightImage tui-fateher"
            style="
              width: 711px;
              height: 900px;
              margin: 0 auto;
              margin-top: 80px;
            "
          >
            <get-img-url
              :imgUrl="item.Answer[0].Content"
              :width="711"
              :height="900"
            ></get-img-url>
          </div>
        </div>
      </div>
      <!-- 视频 -->
      <div class="pageBody" v-if="item.Type == 9 && isVideo">
        <div class="bgFFF PlateIdNine">
          <div
            class="PlateIdTitle"
            style="padding-top: 0.54rem; padding-bottom: 62px"
          >
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div style="padding: 20px">
            <div class="flex-center">
              <upload-self
                v-if="item.Answer[0]"
                action="/api/Img/UploadFile/"
                :width="469"
                :value="item.Answer[0].Content"
                :height="267"
                type="noBorder"
                fileType="video"
                :flag="0"
              />
            </div>
            <div style="margin: 20px auto" class="ql-snow">
              <div
                class="PlateIdText ql-editor"
                v-html="item.Answer[1].Content"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 视频2 -->
      <div class="pageBody" v-if="item.Type == 13 && isVideo">
        <div class="bgFFF PlateIdNine">
          <div
            class="PlateIdTitle"
            style="padding-top: 0.54rem; padding-bottom: 62px"
          >
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div style="padding: 20px">
            <div style="padding: 0 0 13px 0; font-size: 14px">老师来加油</div>
            <div class="flex-center">
              <upload-self
                v-if="item.Answer[0]"
                action="/api/Img/UploadFile/"
                :width="523"
                :height="330"
                :value="item.Answer[0].Content"
                type="noBorder"
                fileType="video"
                :flag="0"
              />
            </div>
            <div style="margin: 20px auto" class="ql-snow">
              <div
                class="PlateIdText ql-editor"
                v-html="item.Answer[1].Content"
              ></div>
            </div>
          </div>
          <div style="padding: 20px">
            <div style="padding: 0 0 13px 0; font-size: 14px">家长来加油</div>
            <div class="flex-center">
              <upload-self
                v-if="item.Answer[2]"
                action="/api/Img/UploadFile/"
                :width="523"
                :height="330"
                :value="item.Answer[2].Content"
                type="noBorder"
                fileType="video"
                :flag="2"
              />
            </div>
            <div style="margin: 20px auto" class="ql-snow">
              <div
                class="PlateIdText ql-editor"
                v-html="item.Answer[3].Content"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 过程表格1 -->
      <div v-if="item.Type == 11" class="pageBody flex-center">
        <el-row class="demo-el-row">
          <el-col :span="12">
            <div
              class="dark bd-top bd-bottom bd-left bd-right"
              style="display: flex"
            >
              <div class="text-flex">
                {{ item.Answer.titleTab1 }}
              </div>
              <div class="table-input">
                {{ item.Answer.name }}
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="light bd-top bd-bottom bd-right" style="display: flex">
              <div class="text-flex">
                {{ item.Answer.titleTab2 }}
              </div>
              <div class="table-input">
                {{ item.Answer.content }}
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="light bd-bottom bd-left bd-right" style="display: flex">
              <div class="text-flex">
                {{ item.Answer.titleTab3 }}
              </div>
              <div class="table-input">
                {{ item.Answer.looktime }}
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="light bd-bottom bd-right" style="display: flex">
              <div class="text-flex">
                {{ item.Answer.titleTab4 }}
              </div>
              <div class="table-input">
                {{ item.Answer.writename }}
              </div>
            </div>
          </el-col>
          <el-col v-for="(cc, keys) in item.Answer.List" :key="keys">
            <div
              class="light bd-left bd-bottom bd-right"
              style="min-height: 120px; flex-direction: column"
            >
              <input
                v-model="cc.title"
                class="table-textarea"
                style="padding-left: 10px"
                placeholder-style="font-weight: bold;"
                :maxlength="10"
              />
              <div class="table-inputs">{{ cc.desc }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 过程表格2 -->
      <div v-if="item.Type == 12" class="pageBody flex-center">
        <div class="table-header" style="width: 100%">
          <el-row class="demo-el-row">
            <el-col>
              <div
                class="demo-el-col dark bd-top bd-bottom bd-left bd-right"
                style="justify-content: center; min-height: 40px"
              >
                <div class="input-table">
                  {{
                    item.Answer.title ? item.Answer.title : "例:成长记录(四月)"
                  }}
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div
                class="demo-el-col dark bd-bottom bd-left"
                style="min-height: 40px"
              >
                <div
                  class=""
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  表现
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div
                class="demo-el-col dark bd-bottom bd-left"
                style="min-height: 40px"
              >
                <div
                  class=""
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  真棒
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div
                class="demo-el-col dark bd-bottom bd-left"
                style="min-height: 40px"
              >
                <div
                  class=""
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  较好
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div
                class="demo-el-col dark bd-bottom bd-left bd-right"
                style="min-height: 40px"
              >
                <div
                  class=""
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  加油
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row
            class="demo-el-row"
            v-for="(item, index) in item.Answer.List"
            :key="index"
          >
            <el-col :span="12">
              <div class="demo-el-col dark bd-bottom bd-left">
                <div class="input-table" style="">
                  {{ item.manifestation }}
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="demo-el-col dark bd-bottom bd-left">
                <div
                  class=""
                  style="
                    font-size: 16px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  <img
                    :src="
                      item.isActivite == 1
                        ? require('../../assets/state_activite.png')
                        : require('../../assets/state.png')
                    "
                    style="width: 20px; height: 20px"
                    alt=""
                  />
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="demo-el-col dark bd-bottom bd-left">
                <div
                  class=""
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  <img
                    :src="
                      item.isActivite == 2
                        ? require('../../assets/state_activite.png')
                        : require('../../assets/state.png')
                    "
                    lazy-load
                    style="width: 20px; height: 20px"
                    mode=""
                  />
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="demo-el-col dark bd-bottom bd-left bd-right">
                <div
                  class=""
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  <img
                    :src="
                      item.isActivite == 3
                        ? require('../../assets/state_activite.png')
                        : require('../../assets/state.png')
                    "
                    lazy-load
                    style="width: 20px; height: 20px"
                    mode=""
                  />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 观察记录表（学期）表格 -->
      <div v-if="item.Type == 4" class="pageBody flex-center">
        <!-- 表格 -->
        <div
          class=""
          style="
            padding: 10px;
            width: 857px;
            height: 1279px;
            z-index: 10;
            background: rgba(255, 255, 255, 0.8);
            border-radius: 21px;
            overflow: hidden;
          "
        >
          <div
            class="PlateIdTitle"
            style="font-size: 19px; font-weight: 600; padding: 20px 0"
          >
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div class="table" v-if="item.Answer.list.length != 0">
            <div class="tableHeader row border_bottom">
              <div class="lineOne border_right cell">纬度</div>
              <div class="lineTwo border_right cell">要素</div>
              <div class="lineThere cell">观察点</div>
            </div>
            <div
              class="row"
              v-for="(row, indexRow) in item.Answer.list"
              :key="indexRow"
            >
              <div class="lineOne cell border_right border_left border_bottom">
                {{ row.Name }}
              </div>
              <div style="flex: 1">
                <div
                  style="display: flex"
                  v-for="(twoLine, twoLineIndex) in row.info"
                  :key="twoLineIndex"
                >
                  <div class="cell border_bottom border_right lineTwo">
                    {{ twoLine.Name }}
                  </div>
                  <div class="lineThere">
                    <div
                      class="cell"
                      v-for="(ThereLine, ThereLineIndex) in twoLine.info"
                      :key="ThereLineIndex"
                    >
                      <div
                        style="flex: 1"
                        class="border_bottom border_right textHiddent"
                      >
                        {{ ThereLine.Name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 观察记录表（学期）文字 -->
      <div v-if="item.Type == -4" class="pageBody flex-center">
        <!-- 表格 -->
        <div
          class="semesterTextBox"
          style="
            padding: 30px;
            width: 857px;
            height: 1279px;
            z-index: 10;
            background: rgba(255, 255, 255, 0.8);
            border-radius: 21px;
            overflow: hidden;
          "
        >
          <div
            v-for="(item, index) in item.Answer.cycleWrites"
            :key="index"
            :style="{ height: index == 0 ? '400px' : '' }"
          >
            <div class="semesterTextTitle">
              {{ !item.Title ? Title : item.Title }}
            </div>
            <div class="semesterTextInput">
              {{ item.Desc }}
            </div>
          </div>
        </div>
      </div>
      <!-- 过程记录表 -->
      <div
        class="pageBody flex-center"
        v-if="item.Type == 5 && item.Answer.list.length != 0"
      >
        <div
          class=""
          style="
            padding: 10px;
            width: 857px;
            height: 1300px;
            z-index: 10;
            background: rgba(255, 255, 255, 0.8);
            border-radius: 21px;
            overflow: hidden;
          "
        >
          <div
            class="PlateIdTitle"
            style="font-size: 19px; font-weight: 600; padding: 20px 0 20px 0"
          >
            {{ !item.Title ? Title : item.Title }}
          </div>
          <div
            class="table"
            v-for="(row, indexRow) in item.Answer.list"
            :key="indexRow"
          >
            <div class="tableHeader row">
              <div class="lineOne cell"></div>
              <div class="lineTwo cell" style="width: 1rem"></div>
              <div class="lineThere cell">观察点</div>
              <div class="grade cell">经常发生</div>
              <div class="grade cell">偶尔发生</div>
              <div class="grade cell">从未发生</div>
            </div>
            <div class="row">
              <div class="lineOne cell border_right border_left border_bottom">
                {{ row.Name }}
              </div>
              <div style="flex: 1">
                <div
                  style="display: flex"
                  v-for="(twoLine, twoLineIndex) in row.info"
                  :key="twoLineIndex"
                >
                  <div
                    class="cell border_bottom border_right lineTwo"
                    style="width: 1.125rem"
                  >
                    {{ twoLine.Name }}
                  </div>
                  <div class="lineThere">
                    <div
                      class="cell"
                      style="align-items: initial"
                      v-for="(ThereLine, ThereLineIndex) in twoLine.info"
                      :key="ThereLineIndex"
                    >
                      <div
                        style="flex: 1"
                        class="border_bottom border_right textHiddent grade"
                      >
                        {{ ThereLine.Name }}
                      </div>
                      <div
                        class="grade cell border_bottom border_right"
                        @click="
                          check(indexRow, twoLineIndex, ThereLineIndex, 1)
                        "
                      >
                        <span v-if="ThereLine.Value == 1" class="check"></span>
                        <span v-else class="noCheck"></span>
                      </div>
                      <div
                        class="grade cell border_bottom border_right"
                        @click="
                          check(indexRow, twoLineIndex, ThereLineIndex, 2)
                        "
                      >
                        <span v-if="ThereLine.Value == 2" class="check"></span>
                        <span v-else class="noCheck"></span>
                      </div>
                      <div
                        class="grade cell border_bottom border_right"
                        @click="
                          check(indexRow, twoLineIndex, ThereLineIndex, 3)
                        "
                      >
                        <span v-if="ThereLine.Value == 3" class="check"></span>
                        <span v-else class="noCheck"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="textareaTitle">{{ row.Title }}</div>
            <div class="textareaText">
              {{ row.Describe }}
            </div>
          </div>
          <div class="textareaTitle" style="padding: 0 0 10px 0">
            {{ item.Answer.Title }}
          </div>
          <div class="textareaText">
            {{ item.Answer.CustomerSay }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import download from "../../../util/downLoad";
import {
  StudentGrowReportInfo,
  GoTenantTempDetailOneInfoByCycleWriteCycle,
  GoTenantTempDetailOneInfoByCycleWrite,
  GoTenantTempDetailOneInfoByImgTextRecord,
  MsaveImage,
  SetAutoPdfInfo,
  AutoPdfDownInfo,
} from "@/api/api";
import html2Canvas from "html2canvas";
import uploadSelf from "@/components/upload_self";
import getImgUrl from "../../components/getImgUrl.vue";

export default {
  components: {
    uploadSelf,
    getImgUrl,
  },
  data() {
    return {
      PlateId: 10,
      Answer: [
        {
          Content:
            "是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮",

          //   Content:
          //     "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/2021-12/2021-12-15/20211215152509_7759.jpg",
          Describe: "图片",
          Time: "",
          Type: "image",
          Value: "",
          Operator: 0,
        },
        {
          Content:
            "是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮",

          //   Content:
          //     "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/2021-12/2021-12-15/20211215152509_7759.jpg",
          Describe: "图片",
          Time: "",
          Type: "image",
          Value: "",
          Operator: 0,
        },
        {
          //   Content:
          //     "是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮",

          Content:
            "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/2021-12/2021-12-15/20211215152509_7759.jpg",
          Describe: "图片",
          Time: "",
          Type: "image",
          Value: "",
          Operator: 0,
        },
        {
          // Content:
          //   "是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮",

          Content:
            "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/2021-12/2021-12-15/20211215152509_7759.jpg",
          Describe: "图片",
          Time: "",
          Type: "image",
          Value: "",
          Operator: 0,
        },
        {
          // Content:
          //   "是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮",

          Content:
            "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/2021-12/2021-12-15/20211215152509_7759.jpg",
          Describe: "图片",
          Time: "",
          Type: "image",
          Value: "",
          Operator: 0,
        },
        {
          Content:
            "是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮是否显示下载按钮",

          // Content:
          //   "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/2021-12/2021-12-15/20211215152509_7759.jpg",
          Describe: "图片",
          Time: "",
          Type: "image",
          Value: "",
          Operator: 0,
        },
      ],
      muluList: [], //目录
      isShowDownLoad: false,
      TeacherId: "206",
      TempId: "44",
      CustomerId: "4806",
      info: {
        list: [],
        StudentName: "",
      },
      catalogueList: [],
      Ip: "",
      type: 0,
      id: "",
      GuidList: [],
      isPreview: false,
      TempType: "",
      CycleName: "",
      DataInfo: {},
      Title: "",
      isVideo: true,
      imgUrl: "",
      limit: false,
    };
  },
  mounted() {
    console.log(this.$route.query, "a");
    this.limit = Boolean(this.$route.query.limit);
    if (this.$route.query.Type == 1) {
      this.isPreview = true;
      setTimeout(() => {
        this.onThreeAuto();
      }, 1000);
    }
  },
  created() {
    let Data;
    Data = JSON.parse(unescape(this.$route.query.info));
    //console.log(Data);
    this.DataInfo = Data;
    if (Data.isPreview) {
      this.isPreview = Data.isPreview;
      this.id = Data.Id;
      this.CustomerId = Data.CustomerId;
      this.TempType = Data.TempType;
      this.CycleName = Data.CycleName;
      this.Title = Data.Title;
      this.record();
    } else {
      this.TeacherId = Data.TeacherId;
      this.TempId = Data.TempId;
      this.CustomerId = Data.CustomerId;
      this.TempType = Data.TempType;
      this.CycleName = Data.CycleName;
      this.Title = Data.Title;
      this.StudentGrowReportInfo();
    }
  },
  methods: {
    getContainImageUrl(url, width, height) {
      if (!url || !width || !height) {
        return url || "";
      }

      if (!/^https?:\/\//.test(url)) {
        return url;
      }

      const [baseUrl, queryString] = url.split("?");
      const query = queryString
        ? queryString
            .split("&")
            .filter((param) => !param.startsWith("x-oss-process="))
            .join("&")
        : "";
      const cleanUrl = query ? `${baseUrl}?${query}` : baseUrl;
      const connector = cleanUrl.includes("?") ? "&" : "?";
      return `${cleanUrl}${connector}x-oss-process=image/resize,m_lfit,w_${width},h_${height}`;
    },
    getImageSize(url) {
      return new Promise(function (resolve, reject) {
        let image = new Image();
        image.onload = function () {
          resolve({
            width: image.width,
            height: image.height,
          });
        };
        image.onerror = function () {
          reject(new Error("error"));
        };
        image.src = url;
      });
    },
    getObjectFitSize(
      type = "contain",
      containerWidth,
      containerHeight,
      imgWidth,
      imgHeight
    ) {
      let radio = 1, // 容器与图片的比例
        sx = 0, // 开始剪切的 x 坐标位置。
        sy = 0, // 开始剪切的 y 坐标位置。
        swidth = imgWidth, // 被剪切图像的宽度。
        sheight = imgHeight, // 被剪切图像的高度。
        x = 0, // 在画布上放置图像的 x 坐标位置。
        y = 0, // 在画布上放置图像的 y 坐标位置。
        width = containerWidth, // 要使用的图像的宽度（伸展或缩小图像）。
        height = containerHeight; // 要使用的图像的高度（伸展或缩小图像）。
      let cWHRatio = containerWidth / containerHeight;
      let iWHRatio = imgWidth / imgHeight;
      if (type === "cover") {
        // cover模式，需要裁剪
        if (iWHRatio >= cWHRatio) {
          // 横图，高先匹配，裁剪宽度
          radio = containerHeight / imgHeight;
          sx = (imgWidth - containerWidth / radio) / 2;
          swidth = containerWidth / radio;
          sheight = imgHeight;
        } else {
          // 竖图，宽先匹配，裁剪高度
          radio = containerWidth / imgWidth;
          sy = (imgHeight - containerHeight / radio) / 2;
          swidth = imgWidth;
          sheight = containerHeight / radio;
        }
      } else if (type === "contain") {
        if (iWHRatio >= cWHRatio) {
          // 横图，宽先匹配，高度自适应
          radio = containerWidth / imgWidth;
          y = (containerHeight - imgHeight * radio) / 2;
          height = imgHeight * radio;
        } else {
          // 竖图，高先匹配，宽度自适应
          radio = containerHeight / imgHeight;
          x = (containerWidth - imgWidth * radio) / 2;
          width = imgWidth * radio;
        }
      }
      return {
        sx,
        sy,
        swidth,
        sheight,
        x,
        y,
        width,
        height,
      };
    },
    getReplace(val) {
      let arr = [];
      let text2 = "";
      val.split("\n").forEach((item) => arr.push(`<p>${item.trim()}</p>`));
      text2 = arr.join("<br>");
      //console.log(text2);
      return text2;
      // return val.replace(/ /g, "&emsp;");
    },
    downloadfile(url, strFileName, strMimeType) {
      var xmlHttp = null;
      if (window.ActiveXObject) {
        // IE6, IE5 浏览器执行代码
        xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
      } else if (window.XMLHttpRequest) {
        // IE7+, Firefox, Chrome, Opera, Safari 浏览器执行代码
        xmlHttp = new XMLHttpRequest();
      }
      //2.如果实例化成功，就调用open（）方法：
      if (xmlHttp != null) {
        xmlHttp.open("get", url, true);
        xmlHttp.responseType = "blob"; //关键
        xmlHttp.send();
        xmlHttp.onreadystatechange = doResult; //设置回调函数
      }
      function doResult() {
        if (xmlHttp.readyState == 4) {
          //4表示执行完成
          if (xmlHttp.status == 200) {
            //200表示执行成功

            download(xmlHttp.response, strFileName, strMimeType);
          }
        }
      }
    },
    uq(array) {
      //将array数组转换成set对象,再使用Array.from()方法将set对象转换成数组
      return Array.from(new Set(array));
    },
    guid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    onThree() {
      let that = this;
      var Name = this.info.StudentName + "_" + this.info.Title + "_";
      this.isVideo = false;
      const loading = this.$loading({
        lock: true,
        text: "正在下载PDF中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(() => {
        let length = this.info.list.length;
        let pageSize = 5; //每次向后台发送十张
        let page = Math.ceil(length / pageSize); //需要发送的次数
        let i = 0; //当前发送的次数
        // 递归函数
        async function fn() {
          // length
          let End =
            pageSize * i + pageSize <= length
              ? pageSize * i + pageSize
              : length;
          let pageBase = [];
          for (let index = pageSize * i; index < End; index++) {
            let content = document.querySelector("#page" + index);
            let canvas = await html2Canvas(content, {
              useCORS: true,
              dpi: 172, //导出pdf清晰度
              scale: 2, // 提升画面质量，但是会增加文件大小
            });
            let pageData = canvas.toDataURL("image/jpeg", 1.0);
            pageBase.push({
              guid: index + 100 + "_" + that.guid(),
              baseimg: pageData,
              name: "#page" + index,
            });
            // //console.log(pageData, "pageBase");
          }
          that.GuidList = that.GuidList.concat(pageBase);

          i++;
          let xhr = await MsaveImage({
            // name: "成长手册",
            list: pageBase,
          });
          //console.log("xhr:" + i, xhr);
          if (i < page) {
            setTimeout(() => {
              fn();
            }, 500);
          } else {
            that.GuidList.forEach((a) => {
              a.baseimg = "";
            });
            //console.log(that.uq(that.GuidList), "that.uq(that.GuidList)");
            SetAutoPdfInfo({
              name: `${Name}成长足迹.pdf`,
              list: that.uq(that.GuidList),
            }).then((res) => {
              loading.close();
              //console.log(res, "res");
              if (res.data.success) {
                //this.isVideo = true;
                let idx = res.data.response.lastIndexOf(".");
                if (idx != -1) {
                  let ext = res.data.response.substr(idx + 1).toUpperCase();
                  ext = ext.toLowerCase();
                  that.downloadfile(
                    res.data.response,
                    `${Name}成长足迹.pdf`,
                    ext
                  );
                }
              } else {
                that.$message({
                  type: "error",
                  message: res.data.msg,
                });
              }
            });
          }
        }
        fn();
      }, 500);
    },

    onThreeAuto() {
      let that = this;
      var Name = this.info.StudentName + "_" + this.info.Title + "_";
      this.isVideo = false;
      const loading = this.$loading({
        lock: true,
        text: "正在下载PDF",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(() => {
        let length = this.info.list.length;
        let pageSize = 5; //每次向后台发送十张
        let page = Math.ceil(length / pageSize); //需要发送的次数
        let i = 0; //当前发送的次数
        // 递归函数
        async function fn() {
          // length
          let End =
            pageSize * i + pageSize <= length
              ? pageSize * i + pageSize
              : length;
          let pageBase = [];
          for (let index = pageSize * i; index < End; index++) {
            let content = document.querySelector("#page" + index);
            let canvas = await html2Canvas(content, {
              useCORS: true,
              dpi: 172, //导出pdf清晰度
              scale: 2, // 提升画面质量，但是会增加文件大小
            });
            let pageData = canvas.toDataURL("image/jpeg", 1.0);
            pageBase.push({
              guid: index + 100 + "_" + that.guid(),
              baseimg: pageData,
              name: "#page" + index,
            });
          }
          that.GuidList = that.GuidList.concat(pageBase);

          i++;
          let xhr = await MsaveImage({
            // name: "成长手册",
            list: pageBase,
          });
          //console.log("xhr:" + i, xhr);
          if (xhr.data.success == false) {
            that.$message({
              type: "error",
              message: "生成失败",
            });
            loading.close();
            return;
          }

          if (i < page) {
            setTimeout(() => {
              fn();
            }, 500);
          } else {
            that.GuidList.forEach((a) => {
              a.baseimg = "";
            });
            //console.log(that.uq(that.GuidList), "that.uq(that.GuidList)");
            AutoPdfDownInfo({
              name: `${Name}成长足迹.pdf`,
              list: that.uq(that.GuidList),
            }).then((res) => {
              loading.close();
              //console.log(res, "res");
              if (res.data.success) {
                //this.isVideo = true;
                window.close();
              } else {
                that.$message({
                  type: "error",
                  message: res.data.msg,
                });
              }
            });
          }
        }
        fn();
      }, 500);
    },

    async record() {
      if (this.typeNum == 4) {
        this.GoTenantTempDetailOneInfoByCycleWriteCycle(this.id);
      } else if (this.typeNum == 5) {
        await this.GoTenantTempDetailOneInfoByCycleWrite(this.id);
      } else {
        await this.GoTenantTempDetailOneInfoByImgTextRecord(this.id);
      }
    },
    async GoTenantTempDetailOneInfoByCycleWriteCycle(Id) {
      let xhr = await GoTenantTempDetailOneInfoByCycleWriteCycle({
        Id: Id,
        StudentId: this.CustomerId,
      });
      if (xhr.data.success) {
        this.info = this.dataProcessing({
          list: [xhr.data.response],
        });
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    async GoTenantTempDetailOneInfoByCycleWrite(Id) {
      let xhr = await GoTenantTempDetailOneInfoByCycleWrite({
        Id: Id,
        StudentId: this.CustomerId,
      });
      if (xhr.data.success) {
        this.info = this.dataProcessing({
          list: [xhr.data.response],
        });
        // this.info.list.push(xhr.data.response);
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    async GoTenantTempDetailOneInfoByImgTextRecord(Id) {
      let xhr = await GoTenantTempDetailOneInfoByImgTextRecord({
        Id: Id,
        StudentId: this.CustomerId,
        IsWeb: 1,
      });
      if (xhr.data.success) {
        this.info = this.dataProcessing({
          list: [xhr.data.response],
        });
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    getRadioValue(value, list) {
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        if (value == element.value) {
          return element.title;
        }
      }
      return "";
    },
    isRichText(str) {
      const pattern = /<("[^"]*"|'[^']*'|[^'">])*>/;
      return pattern.test(str);
    },
    // 处理数据
    dataProcessing(response) {
      let arr = [];
      response.list.forEach((element) => {
        if (!element.BackCoverImg) {
          element.BackCoverImg = require("@/assets/defaultBg.png");
        }
        if (element.Answer) {
          try {
            element.Answer = JSON.parse(element.Answer);
            element.Answer.forEach(async (imageItem) => {
              console.log(imageItem.Content, "imageItem.Content");

              if (this.isRichText(imageItem.Content)) {
                console.log("是富文本");
                imageItem.isText = true;
              } else {
                console.log("不是富文本");
                imageItem.isText = false;
              }

              if (imageItem.Type == "image" && !imageItem.Content) {
                imageItem.Content = require("@/assets/avatar.jpg");
                imageItem.width = 200;
                imageItem.height = 300;
              } else if (imageItem.Type == "image" && imageItem.Content) {
                let size = await this.getImageSize(imageItem.Content);
                imageItem.width = size.width;
                imageItem.height = size.height;
                console.log(imageItem, "size");
                // imageItem.Content +=
                //   "?x-oss-process=style/imgset&&" + new Date().getTime();
              }
            });
          } catch (error) {
            if (element.Answer == "") {
              element.Answer = [];
            }
          }
        }
        if (element.Content) {
          try {
            let arr = [];
            element.Content = JSON.parse(element.Content);
            if (element.Type == 8) {
              //处理体检
              element.Content.forEach((item) => {
                if (item.isOpen) {
                  if (item.child) {
                    arr.push(...item.child);
                  } else {
                    arr.push(item);
                  }
                }
              });

              element.Content = arr;
            }
          } catch (error) {
            element.Content = [];
          }
        }
        if (element.Type != 4 && element.Type != 9) {
          arr.push(element);
        } else if (element.Type == 4) {
          arr.push(JSON.parse(JSON.stringify(element)));
          let elementCopy = JSON.parse(JSON.stringify(element));
          elementCopy.Type = -4;
          arr.push(elementCopy);
        }
      });
      response.list = arr;

      return response;
    },
    async StudentGrowReportInfo() {
      let xhr = await StudentGrowReportInfo(
        {
          TeacherId: this.TeacherId,
          TempId: this.TempId,
          StudentId: this.CustomerId,
          IsWeb: 1,
        },
        this.Ip
      );
      if (xhr.data.success) {
        // this.info = xhr.data.response;
        this.info = this.dataProcessing(xhr.data.response);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.tui-text {
  max-width: 100%;
  height: auto;
  min-height: 157px;

  vertical-align: bottom;
  transition: all 0.3s, height 0s;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-block;
  width: 100%;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 26px;

  // background-color: rgba(255,255,255,0.5);
  background-image: none;
  // border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all 0.3s;
}
/deep/.el-textarea__inner {
  border: none;
  opacity: 1;
  resize: none;
}
/deep/.el-textarea.is-disabled .el-textarea__inner {
  background: none;
  color: #333;
}
#container {
  width: 1000px;
  margin: 0 auto;
}
.tui-fateher {
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    display: block;
    object-fit: contain;
  }
}
.tui-bgHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 122px;
  left: 0;
  right: 0;
  width: 800px;
  margin: 0 auto;
}
.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-textarea {
  width: 20%;
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  padding-top: 10px;
  margin: 0 auto;
  // background: rgb(198, 232, 255);
  text-align: left;
}
.table-inputs {
  width: 90%;
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  padding: 10px;
  word-wrap: break-word;
  text-align: left;
  // margin: 0 auto;
  // background: rgb(198, 232, 255);
}
.table-input {
  // width: 100%;
  height: 50px;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-flex {
  max-width: 110px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  padding-left: 10px;
  flex-shrink: 0;
}
.demo-el-row {
  width: 95%;
  margin: 0 auto;
}
input {
  border: 0; // 去除未选中状态边框
  outline: none; // 去除选中状态边框
  background-color: rgba(0, 0, 0, 0); // 透明背景
}
.bd-top {
  border-top: 1px solid #000000;
}

.bd-bottom {
  border-bottom: 1px solid #000000;
}

.bd-left {
  border-left: 1px solid #000000;
}

.bd-right {
  border-right: 1px solid #000000;
}
.demo-el-col {
  min-height: 80px;
  display: flex;
  align-items: center;
  padding: 0 10px 0 10px;
}
.input-table {
  font-size: 14px;
  display: inline-block;
  // height: 30px;
  // line-height: 30px;
  color: #000;
  white-space: normal;
  word-break: break-all;
}
.semesterTextBox {
  padding-top: 34px;
  box-sizing: border-box;
  .semesterTextTitle {
    width: 100%;
    height: 0.575rem;
    line-height: 0.575rem;
    background: #dce4ff;
    font-size: 14px;
    text-align: center;
    color: #333333;
    font-weight: bold;
  }
  .semesterTextInput {
    min-height: 2rem;
    font-size: 13px;
    color: #333333;
    box-sizing: border-box;
    padding: 0.1rem;
  }
}
.textareaTitle {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  padding: 15px 0;
  // line-height: 20px;
  // padding: 10px;
}
.textareaText {
  border: 1px solid #cdcdcd;
  font-size: 13px;
  font-weight: 500;
  color: #333333;
  padding: 0.075rem;
  margin-bottom: 0.2rem;
  height: 71px;
}
// 表格
.table {
  margin: 0;
  width: 100%;
  .textHiddent {
    // text-overflow: -o-ellipsis-lastline;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // display: -webkit-box;
    // -webkit-line-clamp: 1;
    // line-clamp: 1;
    // -webkit-box-orient: vertical;
    padding: 0.075rem;
    box-sizing: border-box;
  }
  .row {
    display: flex;
  }
  .tableHeader {
    font-size: 0.24rem;
    background-color: #dce4ff;
    min-height: 0.44rem;
  }
  .cell {
    box-sizing: border-box;
    text-align: center;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333333;
    font-size: 14px;
  }
  .border_bottom {
    border-bottom: solid 1px #cdcdcd;
  }
  .border_top {
    border-top: solid 1px #cdcdcd;
  }
  .border_left {
    border-left: solid 1px #cdcdcd;
  }
  .border_right {
    border-right: solid 1px#CDCDCD;
  }
  .lineOne {
    width: 86px;
  }
  .lineTwo {
    width: 96px;
    display: flex;
  }
  .lineThere {
    flex: 1;
  }
  .lineFour {
    width: 2rem;
    // flex: 1;
  }
  .grade {
    width: 0.6875rem;
    padding: 0.075rem;
    font-size: 13px;
    // height: 100%;
    .check {
      width: 0.24rem;
      height: 0.24rem;
      background: #22bbcb;
      display: block;
      border-radius: 50%;
    }
    .noCheck {
      width: 0.24rem;
      height: 0.24rem;
      background: #cdcdcd;
      display: block;
      border-radius: 50%;
    }
  }
}
.PlateIdTenText {
  width: 450px;
  margin: 0 auto;
  height: 330px;
  -webkit-line-clamp: 10; //块元素显示文本行数
}
.PlateIdNine {
  .PlateIdNineImage {
    width: 711px;
    height: 531px;
    margin: 0 auto;
  }
  .PlateIdNineText {
    width: 711px;
    margin: 0 auto;
    height: 264px;
    margin-top: 76px;
    -webkit-line-clamp: 8; //块元素显示文本行数
    box-sizing: content-box;
  }
}
.PlateIdEightText {
  .PlateIdEightImage {
    position: absolute;
    object-fit: contain;
  }
  .PlateIdEightImage:nth-child(1) {
    width: 356px;
    height: 689px;
    top: 0;
    left: 71px;
  }
  .PlateIdEightImage:nth-child(2) {
    width: 304px;
    height: 224px;
    top: 0;
    right: 71px;
  }
  .PlateIdEightImage:nth-child(3) {
    width: 304px;
    height: 206px;
    top: 250px;
    right: 71px;
  }
  .PlateIdEightImage:nth-child(4) {
    width: 304px;
    height: 206px;
    top: 480px;
    right: 71px;
  }
  .PlateIdEightText:nth-child(5) {
    position: absolute;
    width: 721px;
    height: 264px;
    top: 740px;
    right: 71px;
    -webkit-line-clamp: 8; //块元素显示文本行数
  }
}
.PlateIdSevenText {
  .PlateIdSevenImage {
    position: absolute;
    object-fit: contain;
  }
  .PlateIdSevenImage:nth-child(1) {
    width: 711px;
    height: 306px;
    top: 0;
    left: 70px;
  }
  .PlateIdSevenImage:nth-child(2) {
    height: 306px;
    width: 334px;
    top: 356px;
    left: 70px;
  }
  .PlateIdSevenImage:nth-child(3) {
    height: 306px;
    width: 334px;
    top: 356px;
    right: 74px;
  }
  .PlateIdSixText:nth-child(4) {
    position: absolute;
    width: 711px;
    // height: 297px;
    top: 875px;
    left: 70px;
    -webkit-line-clamp: 9; //块元素显示文本行数
  }
}
.PlateIdSix {
  .PlateIdSixImage {
    width: 711px;
    height: 643px;
    // display: block;
    margin: 0 auto;
    margin-top: 0.91rem;
  }
  .PlateIdSixText {
    width: 711px;
    margin: 0 auto;
    -webkit-line-clamp: 8; //块元素显示文本行数
    height: 264px;
  }
}
.PlateIdFive {
  .PlateIdFourImage {
    position: absolute;
    object-fit: contain;
  }
  .PlateIdFourImage:nth-child(1) {
    width: 198px;
    height: 184px;
    right: 214px;
    top: 51px;
  }
  .PlateIdFourImage:nth-child(2) {
    width: 180px;
    height: 235px;
    left: 441px;
    top: 0;
  }
  .PlateIdFourImage:nth-child(3) {
    width: 136px;
    height: 136px;
    right: 651px;
    top: 99px;
  }
  .PlateIdFourImage:nth-child(4) {
    width: 224px;
    height: 287px;
    right: 70px;
    top: 266px;
  }
  .PlateIdFourImage:nth-child(5) {
    width: 224px;
    height: 287px;
    right: 314px;
    top: 266px;
  }
  .PlateIdFourImage:nth-child(6) {
    width: 224px;
    height: 287px;
    right: 561px;
    top: 266px;
  }
  .PlateIdFourImage:nth-child(7) {
    width: 148px;
    height: 169px;
    right: 235px;
    top: 579px;
  }
  .PlateIdFourImage:nth-child(8) {
    width: 223px;
    height: 257px;
    right: 413px;
    top: 579px;
  }
  .PlateIdFourImage:nth-child(9) {
    width: 122px;
    height: 210px;
    right: 666px;
    top: 579px;
  }
  .PlateIdFourImage:nth-child(10) {
    width: 122px;
    height: 101px;
    right: 666px;
    top: 820px;
  }
}
.PlateIdFour {
  .PlateIdFourImage {
    position: absolute;
    object-fit: contain;
  }
  .PlateIdFourImage:nth-child(1) {
    width: 198px;
    height: 184px;
    left: 214px;
    top: 51px;
  }
  .PlateIdFourImage:nth-child(2) {
    width: 180px;
    height: 235px;
    left: 441px;
    top: 0;
  }
  .PlateIdFourImage:nth-child(3) {
    width: 136px;
    height: 136px;
    left: 651px;
    top: 99px;
  }
  .PlateIdFourImage:nth-child(4) {
    width: 224px;
    height: 287px;
    left: 70px;
    top: 266px;
  }
  .PlateIdFourImage:nth-child(5) {
    width: 224px;
    height: 287px;
    left: 314px;
    top: 266px;
  }
  .PlateIdFourImage:nth-child(6) {
    width: 224px;
    height: 287px;
    left: 561px;
    top: 266px;
  }
  .PlateIdFourImage:nth-child(7) {
    width: 148px;
    height: 169px;
    left: 235px;
    top: 579px;
  }
  .PlateIdFourImage:nth-child(8) {
    width: 223px;
    height: 257px;
    left: 413px;
    top: 579px;
  }
  .PlateIdFourImage:nth-child(9) {
    width: 122px;
    height: 210px;
    left: 666px;
    top: 579px;
  }
  .PlateIdFourImage:nth-child(10) {
    width: 122px;
    height: 101px;
    left: 666px;
    top: 820px;
  }
}
.PlateIdThere {
  .PlateIdThereText {
    width: 711px;
    margin: 0 auto;
    height: 198px;
    margin-bottom: 30px;
    -webkit-line-clamp: 6; //块元素显示文本行数
    box-sizing: content-box;
    word-wrap: break-word;
  }
  .PlateIdThereImage {
    width: 711px;
    height: 531px;
    margin: 0 auto;
  }
}
.PlateIdTwo {
  div,
  img {
    position: absolute;
    -webkit-line-clamp: 10; //块元素显示文本行数
  }
  .PlateIdTwoText {
    padding-top: 0.1rem;
  }
  .PlateIdTwoImage:nth-child(1) {
    width: 354px;
    height: 335px;
    top: 0;
    left: 44px;
  }
  .PlateIdTwoText:nth-child(2) {
    width: 354px;
    height: 200px;
    top: 0;
    right: 44px;
  }
  .PlateIdTwoText:nth-child(3) {
    width: 354px;
    height: 200px;
    top: 397px;
    left: 44px;
  }
  .PlateIdTwoImage:nth-child(4) {
    width: 354px;
    height: 335px;
    top: 340px;
    right: 44px;
  }
  .PlateIdTwoImage:nth-child(5) {
    width: 354px;
    height: 335px;
    top: 781px;
    left: 44px;
  }
  .PlateIdTwoText:nth-child(6) {
    width: 354px;
    height: 200px;
    top: 781px;
    right: 44px;
  }
}
.PlateIdOneText {
  // height: 99px;
  width: 711px;
  margin: 0 auto;

  // -webkit-line-clamp: 3; //块元素显示文本行数
}
.positionBox {
  position: relative;
  width: 857px;
}
.PlateIdImage {
  display: block;
  object-fit: contain;
}
.PlateIdOneImage {
  width: 711px;
  margin: 0 auto;
  margin-top: 50px;
  height: 335px;
}
.PlateIdText {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  white-space: pre-wrap;
}
.PlateIdTitle {
  font-size: 48px;
  font-weight: 500;
  text-align: center;
  color: #333333;
}
.page {
  position: relative;
  width: 1000px;
  height: 1421.42px;
  background-size: 100% 100%;
}
.pageBody {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 99;
}
.bgFFF {
  width: 857px;
  height: 1279px;
  //   position: absolute;
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translateX(70px) translateY(70px);
  background: rgba(255, 255, 255, 0.8);
  border-radius: 21px;
  overflow: hidden;
}
.bgFFFCircle {
  width: 857px;
  height: 857px;
  //   position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(70px) translateY(282px);
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
}
.cover {
  .avater {
    width: 756px;
    height: 756px;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;

    margin: auto;
  }
  .TempType {
    // position: absolute;
    // top: 8.52rem;
    // left: 00.92rem;
    font-size: 1.54rem;
    color: rgba(255, 255, 255, 0.5);
    font-family: "font";
    font-weight: 600;
  }
  .CycleName {
    // position: absolute;
    // top: 9rem;
    // left: 00.92rem;
    font-size: 0.4rem;
    color: rgba(255, 255, 255, 0.5);
    font-family: "font";
    font-weight: 500;
  }
  .studentName {
    font-size: 0.69rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.5);
    padding-bottom: 0.3rem;
    // line-height: 0.54rem;
    // position: absolute;
    // top: 8.52rem;
    // right: 0.54rem;
  }
  .ClassName {
    font-size: 0.46rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.5);
    // line-height: 0.54rem;
    // position: absolute;
    // top: 8.93rem;
    // right: 0.54rem;
  }
}

// 目录
.catalogue {
  width: 857px;
  height: 1279px;
  overflow: hidden;
  top: 50%;
  border-radius: 0.16rem;
  left: 50%;
  transform: translateX(70px) translateY(70px);
  background-color: rgba(255, 255, 255, 0.8);
  box-sizing: border-box;
  padding-top: 154px;

  .catalogueItem {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 0 60px;
    box-sizing: border-box;
    padding-bottom: 5px;

    div:nth-child(1) {
      width: 408px;
      overflow: hidden;
      padding-right: 10px;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 22px;
    }
    div:nth-child(2) {
      width: 109px;
      height: 23px;
      background: #67bfc8;
      text-align: center;
      line-height: 23px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 22px;
    }
  }
  .icon {
    width: 224px;
    height: 86px;
    position: absolute;
    top: 46px;
    left: 0;
  }
}
.exercise {
  padding-top: 67px;
  .exerciseItem {
    width: 857px;
    height: 379px;
    border-radius: 0.16rem;
    opacity: 0.8;
    margin: 0 auto;
    margin-bottom: 0.27rem;
    padding: 0.27rem 0.55rem;
    box-sizing: border-box;
    .exerciseTitle {
      font-size: 46px;
      font-weight: 500;
      color: #333333;
      padding-bottom: 23px;
    }
    .exerciseInfo {
      display: flex;
      align-items: center;
      img {
        width: 214px;
        height: 214px;
        object-fit: contain;
      }
      .exerciseValue {
        font-size: 34px;
        font-weight: 500;
        color: #333333;
        padding-left: 60px;
        line-height: 50px;
      }
    }
  }
}
// 体检
.physical {
  .physicalImage {
    width: 711px;
    height: 531px;
    // display: block;
    margin: 0 auto;
    object-fit: contain;
  }
  .physicalTitle {
    font-size: 48px;
    font-weight: 500;
    text-align: center;
    padding-top: 104px;
    padding-bottom: 54px;
    color: #333333;
  }
  .physicalTime {
    font-size: 34px;
    font-weight: 400;
    color: #666666;
    line-height: 48px;
    padding-top: 50px;
    padding-left: 74px;
  }
  .physicalList {
    padding-left: 74px;
    padding-top: 50px;
    display: flex;
    font-size: 34px;
    font-weight: 500;
    color: #333333;
    display: flex;

    flex-wrap: wrap;
    div {
      width: 300px;
      padding-bottom: 30px;
    }
  }
}
.epilogue {
  .epilogueTitle {
    font-size: 46px;
    font-weight: 500;
    text-align: center;
    padding-top: 97px;
    color: #333333;
  }
  .epilogueBody {
    width: 705px;
    height: 720px;
    background: rgba(255, 255, 255, 1);
    border-radius: 21px;
    opacity: 0.8;
    margin: 0 auto;
    margin-top: 185px;
    position: relative;
    box-sizing: border-box;
    padding: 156px 34px 0 34px;
    .epilogueText {
      font-size: 23px;
      font-weight: 400;
      color: #333333;
      line-height: 32px;
    }
    .avaterEpilogue {
      width: 186px;
      height: 186px;
      border-radius: 50%;
      position: absolute;
      // overflow: hidden;
      top: -90px;
      left: 32px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}
.downPage {
  padding: 30px;
  text-align: center;
}
</style>
